import React, { type FC, useEffect } from "react";
import styles from "./styles.module.scss";
import LocationItem from "./LocationItem";
import i18n from "src/i18n";
import { AIC_SELECTED_LANGUAGE_COOKIE_NAME } from "src/constants";
import { Cookies } from "react-cookie";
import publishMetric, { MetricAction } from "src/metrics";
import { useTranslation } from "react-i18next";
import { useLanguage } from "src/components/Contexts/LanguageContext";

const LOCALES = [
  { name: "English", value: "en-US" },
  { name: "Español", value: "es-MX" },
  { name: "Português", value: "pt-BR" },
];

const LanguageList: FC = () => {
  const { t } = useTranslation();
  const cookies = new Cookies();
  const { selectedLanguage, setSelectedLanguage } = useLanguage();

  useEffect(() => {
    cookies.set(AIC_SELECTED_LANGUAGE_COOKIE_NAME, selectedLanguage, {
      path: "/",
    });
    i18n.changeLanguage(selectedLanguage, (err) => {
      publishMetric(MetricAction.CHANGE_LOCALE, {
        errored: !!err,
        value: selectedLanguage,
      });
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedLanguage]);

  return (
    <div className={styles.list_container}>
      <h1>{t("aic_select_preferred_language")}</h1>
      <div className={styles.list}>
        {LOCALES.map((language) => (
          <LocationItem
            key={language.name}
            value={language.value}
            name={language.name}
            isSelected={selectedLanguage === language.value}
            onClick={setSelectedLanguage}
          />
        ))}
      </div>
    </div>
  );
};

export default LanguageList;
